import PropTypes from "prop-types";
import React from "react";
import cx from "classnames";
import styles from "./styles.module.scss";
import { Row, Col } from "react-bootstrap";

import buildUrl from "build-url-ts";
import _ from "lodash";
import SalesforceSandboxConfigurationPage from "./SalesforceSandboxConfigurationPage";
import DeactivateIntegrationContainer from "src/legacy/components/DeactivateIntegration/index";
import LoadingMessage from "src/legacy/components/LoadingMessage";
import PlaceholderEmptyMessage from "src/legacy/components/PlaceholderEmptyMessage";
import DeactivatedSalesforceSandbox from "src/legacy/images/deactivated_salesforce.svg";
import { SalesforceSandboxSidebar } from "./SalesforceSandboxSidebar";
import { localizedStrings } from "src/localization/index.jsx";
import { SalesforceSandboxOnboardingView } from "./SalesforceSandboxOnboardingView";

const apiUrl = `${process.env.REACT_APP_API_URL}`;

class SalesforceSandboxView extends React.Component {
  static contextTypes = {
    store: PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);
    const primaryIntegration = _.get(this.props, "integration");

    this.state = {
      primaryId: _.get(primaryIntegration, "id"),
      deleteConfirmation: false,
      instanceUrl: "",
      errors: {},
      isAuthenticated: false,
      showIntergrationOnboarding: false,
    };

    this.handleAuthenticate = this.handleAuthenticate.bind(this);
    this.handleAuthenticateEvent = this.handleAuthenticateEvent.bind(this);
    this._handleDeactivateClicked = this._handleDeactivateClicked.bind(this);
    this.handleValidate = this.handleValidate.bind(this);
    this.canEdit = this.canEdit.bind(this);
    this.showIntergrationOnboarding = this.showIntergrationOnboarding.bind(this);
    this.handleScroll = this.handleScroll.bind(this);
    this.disableScroll = this.disableScroll.bind(this);

    this.localizedCommons = localizedStrings.commons;
    this.localizedSalesforce = localizedStrings.components.integrations.salesforce;
    this.localizedIntegrations = localizedStrings.components.integrations;
    this.localizedIntgerationActions = localizedStrings.components.integrations.actions;
  }

  componentDidMount() {
    this.props.fetchSalesforceIntegration();
    const integration = localizedStrings.constants.integrationsOnboarding.integrations.salesforce;
    const sections = integration.sections;
    this.setState({
      selectedTab: sections[0].id,
      showIntergrationOnboarding: _.isEmpty(this.props, "integration")
    })
  }

  _handleDeactivateClicked() {
    this.props.fetchTotalSalesforceIntegrations();
    this.setState({
      deleteConfirmation: true,
    });
  }

  handleOverrideAuthenticate() {
    this.setState(
      {
        instanceUrl:
          this.props.integration &&
          this.props.integration.configuration.instance,
      },
      () => {
        this.handleValidate();
      }
    );
  }

  validateAuthError() {
    let integration = this.props.integration;
    if (
      integration.primaryIntegration && _.get(integration, "primaryIntegration.state.code") === "ok") {
      return true;
    } else if ( integration && _.get(integration, "primaryIntegration.id") == null && integration.state.code === "ok") {
      return true;
    }
    return false;
  }

  canEdit() {
    if (_.get(this.props, "user.admin")) {
      return true;
    } else if (
      _.get(this.props, "adminConfiguration.createdBy") &&
      _.get(this.props, "primaryInstanceOverride.configuration")
    ) {
      return (
        _.get(this.props, "adminConfiguration.configuration.email") &&
        _.get(this.props, "adminConfiguration.createdBy.id") ===
          _.get(this.props, "user.id")
      );
    }
    return false;
  }

  showIntergrationOnboarding() {
    this.setState({
      showIntergrationOnboarding: !this.state.showIntergrationOnboarding,
    });
  }

  disableScroll(value) {
    this.setState({
      isScrollDisabled: value,
    });
  }

  handleScroll = (e) => {
    if (this.state.isScrollDisabled) {
      return;
    }
    const integration = localizedStrings.constants.integrationsOnboarding.integrations.salesforce;
    const sections = integration.sections;

    if(sections) {
      const buffer = 25;
      let selectedTabIndex = 0;
      for (let i = 0; i < sections.length; i++) {
        const sectionId = sections[i].id;
        const element = document.getElementById(sectionId);

        if (element) {
          const { top } = element.getBoundingClientRect();
          const position = top;

          if (e.target.scrollTop >= position - buffer) {
            selectedTabIndex = i;
          }
        }
      }

      this.setState({
        selectedTab: sections[selectedTabIndex].id,
      });
    }};

  render() {
    if (this.props.loading) {
      return this._renderLoadingMessage();
    }

    var isAuthenticated = false;

    if ( _.get(this.props, "adminConfiguration.state.code") === "auth_error" && _.get(this.props, "primaryInstanceOverride.configuration.email")) {
      isAuthenticated = true;
    }
    if (this.props.integration && this.validateAuthError() && !this.props.error){
      isAuthenticated = true;
    }

    var isPrimaryTokenExpired = _.get(this.props, "adminConfiguration.state.code") === "auth_error";

    return (
      <div className={styles.content}>
        <Row className={styles.row}>
          <Col md={3} className={styles.left}>
            <SalesforceSandboxSidebar
              integration={this.props.integration}
              handleAuthenticate={this.handleAuthenticate}
              showIntergrationOnboarding={this.showIntergrationOnboarding}
              _handleDeactivateClicked={this._handleDeactivateClicked}
              deactivating={this.props.deactivating}
              canEdit={this.canEdit}
              isAuthenticated={isAuthenticated}
              authenticating={this.props.authenticating}
              isPrimaryTokenExpired={isPrimaryTokenExpired}
              navigate={this.props.navigate}
              showIntergrationOnboardingState={this.state.showIntergrationOnboarding}
              handleIntegrationsBackButton={this.props.handleIntegrationsBackButton}
            />
          </Col>

          <Col md={9} id="right"
            onScroll={(e) => this.handleScroll(e)}
            className={styles.right}
          >
            {!isAuthenticated &&
              _.size(this.props.integration) > 0 &&
              !this.state.showIntergrationOnboarding && (
                <div className={styles.errorContainer}>
                  <PlaceholderEmptyMessage
                    title={this.localizedSalesforce.error_messages.primary_expired.title}
                    message={this.canEdit()? this.localizedSalesforce.error_messages.primary_expired.sub_text : this.localizedSalesforce.error_messages.primary_expired.non_admin}
                    image={DeactivatedSalesforceSandbox}
                    className={styles.emptyMessage}
                    visible={true}
                  />
                </div>
              )}

            {(_.isEmpty(_.get(this.props, 'integration'))|| this.state.showIntergrationOnboarding) && (
              <SalesforceSandboxOnboardingView
                selectedTab={this.state.selectedTab}
                disableScroll={this.disableScroll}
              />
            )}
            {isAuthenticated && this.props.integration && !this.state.showIntergrationOnboarding && (
                <SalesforceSandboxConfigurationPage
                  handleAuthenticate={this.handleAuthenticate}
                  store={this.context.store}
                  isPrimaryTokenExpired={isPrimaryTokenExpired}
                  OverrideConfig={this.handleOverrideAuthenticate.bind(this)}
                  showIntergrationOnboarding={this.showIntergrationOnboarding}
                  isAuthenticated={isAuthenticated}
                  integration={this.props.integration}
                />
              )}
          </Col>
        </Row>
        <DeactivateIntegrationContainer
          name={this.localizedSalesforce.sliders.deactivate.title}
          type="salesforce-sandbox"
          message={this.localizedSalesforce.sliders.deactivate.sub_text}
          show={this.state.deleteConfirmation}
          accountsCount={this.props.totalSalesforceIntegrations}
          onCancel={() => {
            this.setState({
              deleteConfirmation: false,
            });
          }}
          className={styles.salesforceDeactivate}
        />
      </div>
    );
  }

  _validateForm() {
    var errors = {};
    if (!this.state.instanceUrl || this.state.instanceUrl.trim().length == 0) {
      errors["instanceUrl"] =
        this.localizedSalesforce.error_messages.instance_url;
    }

    return errors;
  }

  handleValidate() {
    this.handleAuthenticate();
  }

  _renderLoadingMessage() {
    return (
      <LoadingMessage
        className={styles.loadingMessage}
        message={`${this.localizedSalesforce.loading.config}...`}
        visible={this.props.loading}
      />
    );
  }

  handleAuthenticate() {
    //Calculate Position
    var dualScreenLeft =
      window.screenLeft != undefined ? window.screenLeft : window.screen.left;
    var dualScreenTop =
      window.screenTop != undefined ? window.screenTop : window.screen.top;

    var width = window.innerWidth
      ? window.innerWidth
      : document.documentElement.clientWidth
      ? document.documentElement.clientWidth
      : window.screen.width;
    var height = window.innerHeight
      ? window.innerHeight
      : document.documentElement.clientHeight
      ? document.documentElement.clientHeight
      : window.screen.height;

    var w = 0.8 * width;
    var h = 0.8 * height;

    var left = width / 2 - w / 2 + dualScreenLeft;
    var top = height / 2 - h / 2 + dualScreenTop;

    const url = buildUrl(apiUrl, {
      path: `/api/2.0/integrations/salesforce-sandbox/authorize`,
    });

    var newWindow = window.open(
      url,
      `Authorize salesfoce Account`,
      "scrollbars=yes, width=" +
        w +
        ", height=" +
        h +
        ", top=" +
        top +
        ", left=" +
        left
    );

    // Puts focus on the newWindow
    if (newWindow.focus) {
      newWindow.focus();
    }

    //Attaching message event listner
    var eventMethod = window.addEventListener
      ? "addEventListener"
      : "attachEvent";
    var eventer = window[eventMethod];
    var messageEvent = eventMethod == "attachEvent" ? "onmessage" : "message";

    // Listen to message from child window
    eventer(messageEvent, this.handleAuthenticateEvent, false);
    return false;
  }

  handleAuthenticateEvent(e) {
    //Removing message event listner
    var detachEventMethod = window.removeEventListener
      ? "removeEventListener"
      : "detachEvent";
    var deEventer = window[detachEventMethod];
    var messageEvent =
      detachEventMethod == "detachEvent" ? "onmessage" : "message";

    if (e.data.type == "SALESFORCE_AUTHORIZATION_SUCCESS") {
      var code = e.data.payload.code;
      var state = e.data.payload.state;
      var error = e.data.payload.error;
      var id = this.state.primaryId;
      this.props.trackAdoptionMetricsForPluginConnectedEvent("Salesforce");
      if (!error) {
        {
          this.props.changePrimaryConfiguration(_.get(id, code)).then(() => {
            this.props.fetchSalesforceIntegration();
            this.setState({ authenticatePrimaryExpire: false });
          });
        }
        this.props.authenticateAccount(code);
      }

      deEventer(messageEvent, this.handleAuthenticateEvent, false);
    }
  }
}

export default SalesforceSandboxView;
